<template>
<div class="experience-form">
  <figure class="image is-96x96 is-circular is-centered">
    <img :src="imageUrl" alt="Avatar image">
  </figure>
  <div class="field is-horizontal">
    <div class="field-body">
      <text-field :label="this.$t('profile.role')" v-model.trim="role" />
      <location-field :label="this.$t('profile.location')" v-model="location" />
    </div>
  </div>
  <div class="field is-horizontal">
    <div class="field-body">
      <text-field :label="this.$t('profile.company')" v-model.trim="company" />
      <text-field :label="this.$t('profile.companyUrl')" v-model.trim="companyUrl" />
    </div>
  </div>
  <div class="field is-horizontal">
    <div class="field-body">
      <field :label="this.$t('profile.from')">
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="fromMonth">
              <option v-for="month in months" :key="month">
              {{ month }}
              </option>
            </select>
          </div>
        </div>
        <div class="control">
          <input class="input" type="text" placeholder="Year"
            v-model="fromYear" />
        </div>
      </field>
      <field :label="this.$t('profile.to')" v-if="!currentPosition">
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="toMonth" :disabled="currentPosition">
              <option v-for="month in months" :key="month">
              {{ month }}
              </option>
            </select>
          </div>
        </div>
        <div class="control">
          <input class="input" type="text" :placeholder="this.$t('profile.year')"
          :disabled="currentPosition" v-model="toYear" />
        </div>
      </field>
      <field label="To" v-else>
        <div class="control">
          <p>Present</p>
        </div>
        <div class="control">
          <input class="input hidden" type="text" :placeholder="this.$t('profile.year')"
          :disabled="currentPosition" v-model="toYear" />
        </div>
      </field>
    </div>
  </div>
  <field :label="this.$t('profile.iCurrentWorkHere')">
    <div class="control toggle">
      <toggle v-model="currentPosition" :isEditable="true" />
    </div>
  </field>
</div>
</template>

<script>
import Toggle from '@/components/toggle'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import LocationField from '@/components/general/location-autocomplete-field'
import randomBytes from 'rand-token'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    Toggle, Field, TextField, LocationField
  },
  computed: {
    months () {
      return [
        this.$t('calendar.selectMonth'),
        this.$t('calendar.jan'),
        this.$t('calendar.feb'),
        this.$t('calendar.mar'),
        this.$t('calendar.apr'),
        this.$t('calendar.may'),
        this.$t('calendar.jun'),
        this.$t('calendar.jul'),
        this.$t('calendar.aug'),
        this.$t('calendar.sep'),
        this.$t('calendar.oct'),
        this.$t('calendar.nov'),
        this.$t('calendar.dec')
      ]
    },
    ...mapGetters('experienceForm', [
      'imageUrl'
    ]),
    ...mapState('experienceForm', {
      formFromMonth: state => state.from.month,
      formFromYear: state => state.from.year,
      formToMonth: state => state.to.month,
      formToYear: state => state.to.year,
      formCompany: state => state.company,
      formCompanyUrl: state => state.companyUrl,
      formLocation: state => state.location,
      formRole: state => state.role,
      formCurrentPosition: state => state.currentPosition
    }),
    currentPosition: {
      get () { return this.formCurrentPosition },
      set (value) { this.setCurrentPosition(value) }
    },
    fromMonth: {
      get () { return this.months[this.formFromMonth] },
      set (value) { this.setFromMonth(this.valueForMonth(value)) }
    },
    fromYear: {
      get () { return this.formFromYear },
      set (value) { this.setFromYear(value) }
    },
    toMonth: {
      get () { return this.months[this.formToMonth] },
      set (value) { this.setToMonth(this.valueForMonth(value)) }
    },
    toYear: {
      get () { return this.formToYear },
      set (value) { this.setToYear(value) }
    },
    company: {
      get () { return this.formCompany },
      set (value) { this.setCompany(value) }
    },
    companyUrl: {
      get () { return this.formCompanyUrl },
      set (value) { this.setCompanyUrl(value) }
    },
    location: {
      get () { return this.formLocation },
      set (value) { this.setLocation(value) }
    },
    role: {
      get () { return this.formRole },
      set (value) { this.setRole(value) }
    }
  },
  methods: {
    ...mapMutations('experienceForm', [
      'setFromMonth',
      'setFromYear',
      'setToMonth',
      'setToYear',
      'setCompany',
      'setCompanyUrl',
      'setLocation',
      'setRole',
      'setCurrentPosition'
    ]),
    valueForMonth (month) {
      return this.months.indexOf(month)
    }
  },
  data () {
    return {
      bytes: ''
    }
  },
  mounted () {
    this.bytes = randomBytes.generate(8)
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";

figure.image {
  border: 1px solid #dddddd;
  img {
    background-color: #f3f3f3;
  }
  margin-bottom: 1.5rem;
}

label.disabled {
  opacity: 0.3;
}

.company-message {
  min-height: 36px;
}

.control {
  display: block;
}

.control.toggle {
  padding-top: 0.25rem;
}

.field.is-horizontal {
  margin-bottom: 0;
}

@media screen and (max-width: $tablet) {
  .field.is-horizontal {
    margin-bottom: 1.5rem;
  }
}

.hidden {
  opacity: 0;
}

.control p {
  font-size: 0.875rem;
  margin-top: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/experience-form.vue